import { FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function SameValue(comparedControlPath: string, errorMessage: string): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    if (!control.parent || !control.root) {
      return null;
    }

    const rootControl = control.root;
    const comparedControl = rootControl.get(comparedControlPath);

    if (control.value !== comparedControl.value) {
      return { sameValue: true, errorMessage };
    }
  };
}

export function Pattern(pattern: string | RegExp, errorMessage: string): ValidatorFn {
  const patternValidatorFn = Validators.pattern(pattern);

  return (control: FormControl) => patternValidatorFn(control) === null ? null : { pattern: true, errorMessage };
}

export function MaxValue(maxValue: number, errorMessage: string): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const value = +control.value;

    if (isNaN(value) || !(value <= maxValue)) {
      return { maxValue: true, errorMessage };
    }
  };
}
